const appKey = "fusion2022tour"
const cdnUrl = "https://site.gcores.com"

const info = {
  name: "2022年核聚变，即将开始！期待与你相见",
  description: "早鸟票现已开售",
}

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: info.name,
    description: info.description,
    shareTitle: info.name,
    shareDescription: info.description,
  },
  links: {
    enroll: "https://shimo.im/forms/vwjIuuLGCUUOZ0Ud/fill",
    ticket: "https://b23.tv/BJOstJp",
    talks: "https://www.gcores.com/topics/302",
  },
}
